'use client'

import useSearchStore from '@app/components/search-section/store/search-store'
import {useScrollLock} from '@app/hooks/use-scroll-lock'
import {useEffect} from 'react'

type Props = {
  children: React.ReactNode
}

const FocusVisiblityProvider = ({children}: Props) => {
  const {isFocused} = useSearchStore()
  const {lockScroll, unlockScroll} = useScrollLock()

  useEffect(() => {
    if (isFocused) {
      lockScroll()
    } else {
      unlockScroll()
    }
  }, [isFocused])

  return isFocused && children
}

export default FocusVisiblityProvider
